import { z } from "zod";

/**
 * Request body for `POST /api/coach-manager/clients/search`. Mirrors
 * `ClientSearchCriteria` (`src/lib/coach-manager/types.ts`) field-for-field
 * — `buildClientSearchEnvelope` fills the WSDL-required default (`"EqualTo"`)
 * for the two search operators, so every criteria field stays optional here
 * too (same convention as `contractSearchRequestSchema`).
 */
export const clientSearchRequestSchema = z.object({
  buInstanceId: z.string().min(1, "This field is required"),
  clientId: z.string().optional(),
  firstName: z.string().optional(),
  surname: z.string().optional(),
  initials: z.string().optional(),
  company: z.string().optional(),
  address: z.string().optional(),
  postCode: z.string().optional(),
  telNo: z.string().optional(),
  email: z.string().optional(),
  dateCreated: z.string().optional(),
  dateCreatedOperator: z.enum(["GreaterThan", "EqualTo", "LessThan"]).optional(),
  lastUpdated: z.string().optional(),
  lastUpdatedOperator: z.enum(["GreaterThan", "EqualTo", "LessThan"]).optional(),
});

export type ClientSearchRequest = z.infer<typeof clientSearchRequestSchema>;
